<template>
  <v-card>
    <v-card-text>
      <div class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <v-avatar class="ml-2" size="36px">
            <img alt="Avatar" :src="post.userPic" />
          </v-avatar>
          <h4 class="ml-2">{{ post.userName }}</h4>
          <!-- <strong class="ml-2" v-html="post.userName">{{post.userName}}</strong> -->
        </div>
        <div>
          <span>{{ agoTime(post.date.toDate()) }}</span>
          <v-menu offset-y v-if="canDelete">
            <template v-slot:activator="{ on }">
              <v-btn text icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canDelete" @click="editPost()">
                <v-list-item-title>{{ $t("common.edit") }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDelete" @click="deletePost()">
                <v-list-item-title>{{ $t("common.delete") }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <p class="mt-2 mb-0" style="white-space: pre-line" v-html="formatUrls(post.text)"></p>
      <Attachment class="pb-0" :files="post.files" :post="post" />

      <!--      <div v-if="post.link_metadata" :href="post.link_metadata.url" target="_blank">-->
      <v-card
        v-if="post.link_metadata"
        :href="post.link_metadata.url"
        target="_blank"
        @click="logLinkClick"
      >
        <v-img
          v-if="post.link_metadata.image"
          :src="post.link_metadata.image"
          height="200px"
        ></v-img>

        <v-card-title>
          {{ post.link_metadata.title }}
        </v-card-title>

        <v-card-subtitle>
          {{ post.link_metadata.description }}
        </v-card-subtitle>
      </v-card>
      <div class="mt-1 d-flex align-center">
        <div v-if="canComment">
          <v-btn icon @click="toggleLike()">
            <v-icon v-if="liked" color="primary">mdi-thumb-up</v-icon>
            <v-icon v-else color="primary">mdi-thumb-up-outline</v-icon>
          </v-btn>
          <div>
            <IconUsersTooltip :userIds="likes" :title="$t('feed.postLikesTitle')">
              <template v-slot:default="{ activator }">
                <v-btn
                  text
                  x-small
                  class="grey--text text--darken-2"
                  v-bind="activator.attrs"
                  v-on="activator.on"
                >
                  {{
                    $tc("feed.postLikes", likes.length, {
                      likeCounts: likes.length,
                    })
                  }}</v-btn
                >
              </template>
            </IconUsersTooltip>
          </div>
        </div>
        <div v-if="canComment" class="ml-5">
          <v-icon class="mt-2 mb-1" color="primary">mdi-message</v-icon>
          <div>
            {{
              $tc("feed.postComments", commentsCount, {
                commentsCount: commentsCount,
              })
            }}
          </div>
        </div>
        <div class="ml-5">
          <IconUsersTooltip icon="mdi-" :userIds="seens" :title="$t('feed.postSeensTitle')">
            <template v-slot:default="{ activator }">
              <v-icon v-bind="activator.attrs" v-on="activator.on" class="mt-2 mb-1" color="primary"
                >mdi-eye</v-icon
              >
            </template>
          </IconUsersTooltip>
          <div>
            {{ $tc("feed.postSeens", seens.length) }}
          </div>
        </div>
        <div v-if="linkClicks" class="ml-5">
          <IconUsersTooltip :title="$t('feed.postClicksTitle')" :userIds="linkClicks">
            <template v-slot:default="{ activator }">
              <v-icon v-bind="activator.attrs" v-on="activator.on" class="mt-2 mb-1" color="primary"
                >mdi-link</v-icon
              >
            </template>
          </IconUsersTooltip>
          <div>
            {{ $tc("feed.postClicks", linkClicks.length) }}
          </div>
        </div>
      </div>
      <!-- <span>{{ likesText }}</span> -->
      <div class="d-flex flex-row"></div>
      <PostComments v-if="canComment" :postId="post.id" />
    </v-card-text>
  </v-card>
</template>

<script>
import firestore from "@/firebase/firestore";
import Attachment from "./Attachment";
import PostComments from "./PostComments";
import IconUsersTooltip from "./IconUsersTooltip";

export default {
  props: ["post"],
  components: { Attachment, PostComments, IconUsersTooltip },
  data() {
    return {};
  },
  methods: {
    editPost() {
      this.$emit("edit", this.post.id);
    },
    deletePost() {
      const tripId = this.$store.getters.currentTripId;
      if (this.post.scheduled_date) {
        firestore.deleteDocument(tripId, "scheduled", this.post.id);
      } else {
        firestore.writeTrackedDocument(tripId, "feed", {}, this.post.id, true);
      }
    },
    userPic(userId) {
      return (
        this.$store.getters.getImageUrlById(userId) || require("@/assets/profile_pic_empty.png")
      );
    },
    userName(userId) {
      return this.$store.getters.getUserById(userId).name;
    },
    logLinkClick() {
      const tripId = this.$store.getters.currentTripId;

      const clicks = Object.keys(this.post.url_clicks || {});
      if (clicks.includes(this.userId)) return;

      const update = {};
      update[`url_clicks.${this.userId}`] = true;

      console.log(update);
      firestore.writeTrackedDocument(tripId, "feed", update, this.post.id);
    },
    toggleLike() {
      const tripId = this.$store.getters.currentTripId;
      const path = `likes.${this.userId}`;
      const update = {};

      if (this.liked) {
        console.log("set unlikeed");
        update[path] = firestore.fieldDelete();
      } else {
        console.log("set likeed");
        update[path] = true;
      }
      console.log(update);
      firestore.writeTrackedDocument(tripId, "feed", update, this.post.id);
    },
    formatUrls(text) {
      if (this.validURL(text) && this.post.link_metadata) {
        return "";
      }
      const URLMatcher =
        /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/gim;
      return (text || "").replace(
        URLMatcher,
        (match) => `<a href="${match}" target="_blank">${match}</a>`,
      );
    },
    validURL(str) {
      const pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
          "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i",
      ); // fragment locator
      return !!pattern.test(str);
    },
    agoTime(date) {
      const now = new Date();
      if (now.getTime() > date.getTime()) {
        return `${this.$t("common.time.ago", {
          time: this.$options.filters.timeDistanceFromNow(date, now),
        })}`;
      }
      return `${this.$t("common.time.scheduled")} : ${this.$options.filters.toDate(date, "Pp")}`;
    },
  },
  computed: {
    canComment() {
      if (this.post.allow_comments === undefined) return true;
      return this.post.allow_comments;
    },
    canDelete() {
      const meId = this.userId;
      return this.post.sender_id === meId || this.$store.state.trip.trip.user_ids[meId];
    },
    liked() {
      if (!this.post.likes) return false;
      return Object.keys(this.post.likes).includes(this.userId);
    },
    userId() {
      return this.$store.state.firUser.uid;
    },
    seens() {
      return Object.keys(this.post.seens || {});
    },
    linkClicks() {
      if (this.post.link_metadata) return Object.keys(this.post.url_clicks || {});
      return null;
    },
    likes() {
      return Object.keys(this.post.likes || {});
    },
    commentsCount() {
      if (!this.post.comment_ids) return 0;
      return Object.keys(this.post.comment_ids).length;
    },
  },
};
</script>
